import { useState, useEffect } from "react";
import { EMPLOYEE_MANAGEMENT_SERVICE } from "src/utils/Api";
import __ from "src/utils/Translations";
import useHasPermission from "src/utils/hooks/security/useHasPermission";
import { employeeEmployeeGroupPermissionRead } from "src/utils/RoleBasedSecurity/permissions";
import sendBatchRequests from "src/utils/Api/sendBatchRequests";

export default function useEmployeeGroups(
  asOption = false,
  filterField = null,
  filterValue = null,
  idAsIri = false,
  noFetching = false
) {
  const [data, setData] = useState([]);

  const hasPermission = useHasPermission(employeeEmployeeGroupPermissionRead);
  const skipAction = !hasPermission || noFetching;

  useEffect(() => {
    const fetchData = async () =>
      sendBatchRequests({
        skipAction,
        filterField,
        filterValue,
        idAsIri,
        asOption,
        IRI_PREFIX,
        requestParams: {
          service: EMPLOYEE_MANAGEMENT_SERVICE,
          path: "/employee-groups",
          method: "GET",
          mockData,
          additionalParams: {
            "order[name]": "asc",
          },
        },
        setData,
      });

    fetchData();
  }, [filterField, filterValue, idAsIri, asOption, skipAction, setData]);

  return data;
}

export const IRI_PREFIX = "/api/employee-management/v1/rest/employee-groups";

export const mockData = [
  {
    id: "a43275e4-eeb2-11ea-adc1-0242ac1200021",
    companyId: "a43275e4-eeb2-11ea-adc1-0242ac1200021",
    name: "Użytkownicy",
    active: "Tak",
    employeeCount: "17",
  },
  {
    id: "a43275e4-eeb2-11ea-adc1-0242ac1200022",
    companyId: "a43275e4-eeb2-11ea-adc1-0242ac1200021",
    name: "Byli Użytkownicy",
    active: "Tak",
    employeeCount: "5",
  },
  {
    id: "a43275e4-eeb2-11ea-adc1-0242ac1200023",
    companyId: "a43275e4-eeb2-11ea-adc1-0242ac1200021",
    name: "Nowi użytkownicy",
    active: "Tak",
    employeeCount: "5",
  },
];
